export default __webpack_public_path__ + "static/media/start_project.70367193.png";